import v3ApiClient from "./v3/client";

const OPERATION_BASE_PATH = "/v3/operation";

/**
 * 按机场 + 当地日期列出本站当天起飞的航段（每条带过站检查单进度）。
 * @param {string} station 出发机场三字码
 * @param {string} localDate 本站当地日期，YYYY-MM-DD
 */
export const listStationFlights = (station, localDate) =>
    v3ApiClient.get(`${OPERATION_BASE_PATH}/legs/by-station`, {
        params: { station, local_date: localDate },
    });

/**
 * 列出本组织范围内"有出发航班"的机场，供本站航班页的站点下拉只显示飞过的站点。
 */
export const listChecklistStations = () => v3ApiClient.get(`${OPERATION_BASE_PATH}/legs/station-options`);

/**
 * 生成或获取一张过站检查单（幂等）。第一次调用按模板生成，之后返回现有那张。
 * @param {number} legId FlightOperation ID
 */
export const initRampChecklist = (legId) =>
    v3ApiClient.post(`${OPERATION_BASE_PATH}/legs/${legId}/ramp-checklist:init`);

/**
 * 获取一张过站检查单的当前内容；未生成时 initialized=false。
 * @param {number} legId FlightOperation ID
 */
export const getRampChecklist = (legId) =>
    v3ApiClient.get(`${OPERATION_BASE_PATH}/legs/${legId}/ramp-checklist`);

/**
 * 逐项打卡 / 表头字段保存：复用统一事项更新接口，按记录自身 id 定位、带乐观锁。
 * @param {number} itemId OperationItem ID
 * @param {object} fields 平铺的待更新字段（time/checked/time_manual 或表头字段）
 * @param {number} expectedLockVersion 客户端读到的乐观锁版本
 */
export const patchOperationItem = (itemId, fields, expectedLockVersion) =>
    v3ApiClient.patch(`${OPERATION_BASE_PATH}/items/${itemId}`, {
        fields,
        expected_lock_version: expectedLockVersion,
    });

/**
 * 签名专用动作：只提交手写签名图；签字人由后端按当前登录人写入，前端无法冒名。
 * @param {number} legId FlightOperation ID
 * @param {string} signatureData 手写签名图，PNG dataURL
 */
export const signRampChecklist = (legId, signatureData) =>
    v3ApiClient.post(`${OPERATION_BASE_PATH}/legs/${legId}/ramp-checklist:sign`, { signature_data: signatureData });

/**
 * 完成专用动作：由后端校验"已签名"后标记完成、写入完成时间。
 * @param {number} legId FlightOperation ID
 */
export const completeRampChecklist = (legId) =>
    v3ApiClient.post(`${OPERATION_BASE_PATH}/legs/${legId}/ramp-checklist:complete`);

const rampChecklistApi = {
    listStationFlights,
    listChecklistStations,
    initRampChecklist,
    getRampChecklist,
    patchOperationItem,
    signRampChecklist,
    completeRampChecklist,
};

export default rampChecklistApi;
